module.exports = __webpack_public_path__ + "static/media/patronat_honorowy_prezydent_PL.7ee687bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/patronat_honorowy_prezydent_PL.png
// module id = 1104
// module chunks = 0